<div class="pageheader">
  <div class="page-title">
    <h1>Assembly Artifacts</h1>
    <div class="btn-group">
      <button class="btn btn-link" (click)="refresh()">Refresh <ep-svg-icon icon="repeat"></ep-svg-icon></button>
      <button class="btn btn-link" (click)="uploadMultiple()">Upload multiple <ep-svg-icon icon="paper-clip"></ep-svg-icon></button>
    </div>
  </div>
</div>

<div class="xcontainer xcontainer-fixed">
  <div class="xrow">
    <div class="xcol-sm-12">
      <dx-data-grid biz-grid
        [selection]='{ mode: "none" }'
        [dataSource]='artifacts'
        [bizSetGroupPanel]="true"
        [bizSetColumnChooser]="true"
        [bizSetAllowColumnReordering]="true"
        [bizSetPager]="false"
        (onInitNewRow)="onInitNewRow($event)"
        (onRowInserting)="onRowInserting($event)"
        (onRowUpdating)="onRowUpdating($event)"
        (onRowRemoving)="onRowRemoving($event)"
        (onEditingStart)="onEditingStart($event)"
        (onEditCanceled)="onEditCanceled($event)"
        (onRowValidating)="onRowValidating($event)"
        [bizEditRowOnDoubleClick]="true">

        <dxo-editing mode="popup"
          [allowUpdating]="allowUpdating"
          [allowAdding]="allowAdding"
          [allowDeleting]="allowDeleting">
          <dxo-form [customizeItem]="customizeItem"></dxo-form>
        </dxo-editing>

        <dxo-column-fixing [enabled]="true"></dxo-column-fixing>

        <dxo-group-panel [visible]="false"></dxo-group-panel>

        <dxi-column dataField="Name" caption="Name" dataType="string" sortOrder="asc">
          <dxi-validation-rule type="required"></dxi-validation-rule>
        </dxi-column>
        <dxi-column dataField="Description" caption="Description" dataType="string">
          <dxi-validation-rule type="required"></dxi-validation-rule>
        </dxi-column>
        <dxi-column dataField="AssemblyName" caption="Assembly name" dataType="string" [allowEditing]="false">
          <dxi-validation-rule type="required"></dxi-validation-rule>
        </dxi-column>
        <dxi-column dataField="ClassName" caption="Class name" dataType="string" [allowEditing]="false">
          <dxi-validation-rule type="required"></dxi-validation-rule>
        </dxi-column>
        <dxi-column dataField="AssemblyType" dataType="string" [allowEditing]="false" [visible]="false" [showInColumnChooser]="false">
          <dxi-validation-rule type="required"></dxi-validation-rule>
          <dxo-form-item [visible]="false"></dxo-form-item>
        </dxi-column>
        <dxi-column dataField="AssemblyTypeDisplayName" [groupIndex]="0" caption="Type" dataType="string" [allowEditing]="false">
          <dxi-validation-rule type="required"></dxi-validation-rule>
        </dxi-column>
        <dxi-column dataField="Filename" caption="File" dataType="string" editCellTemplate="fileEditTemplate">
          <dxi-validation-rule type="required"></dxi-validation-rule>
        </dxi-column>

        <dxi-column biz-grid-user dataField="CreatedBy" caption="Created By" [visible]="false">
          <dxo-header-filter [dataSource]="bizGridFiltervalues.getUserFilterData(bizGridFiltervalues.getPropertyValues(artifacts, 'CreatedBy'))"></dxo-header-filter>
        </dxi-column>
        <dxi-column biz-grid-date dataField="CreatedDate" caption="Created Date" [visible]="false" format="dateTime"></dxi-column>
        <dxi-column biz-grid-user dataField="UpdatedBy" caption="Modified By" [visible]="false">
          <dxo-header-filter [dataSource]="bizGridFiltervalues.getUserFilterData(bizGridFiltervalues.getPropertyValues(artifacts, 'UpdatedBy'))"></dxo-header-filter>
        </dxi-column>
        <dxi-column biz-grid-date dataField="UpdatedDate" caption="Modified Date" [visible]="false" format="dateTime"></dxi-column>

        <dxi-column dataField="ArtifactId" caption="Artifact Id" [allowEditing]="false" [visible]="false">
          <dxo-form-item [visible]="false"></dxo-form-item>
        </dxi-column>

        <dxi-column dataField="IsSystemArtifact" caption="Is system" dataType="boolean" [allowEditing]="false" fixed="true" fixedPosition="right">
          <dxo-form-item [visible]="false"></dxo-form-item>
        </dxi-column>

        <dxi-column dataField="IsInternal" caption="Is internal" dataType="boolean" [allowEditing]="false" [visible]="false">
          <dxo-form-item [visible]="false"></dxo-form-item>
        </dxi-column>

        <dxi-column type="buttons">
          <dxi-button name="edit"></dxi-button>
          <dxi-button name="delete"></dxi-button>
          <dxi-button text="Download"
            template="fileDownloadTemplate"
            [visible]="allowShowLog">
          </dxi-button>
          <dxi-button text="Show Log"
            template="logTemplate"
            [visible]="allowShowLog">
          </dxi-button>
        </dxi-column>

        <ng-container *dxTemplate="let cell of 'logTemplate'">
          <app-change-log-link *bizPermissionRequired="'Developer_Action_ShowLog'" [title]="'Log for ' + cell.data.Name" [showIcon]="false" classNames="dx-link">
            <app-change-log-link-entity type="Artifact" [id]="cell.data.ArtifactId"></app-change-log-link-entity>
          </app-change-log-link>
        </ng-container>

        <ng-container *dxTemplate="let cellInfo of 'fileEditTemplate'">
          <span [hidden]="!cellInfo.data.Filename">Current file: {{ cellInfo.data.Filename }}</span>
          <dx-file-uploader [multiple]="false"
            uploadMode="instantly"
            [uploadUrl]="getUploadUrl()"
            [visible]="true"
            [allowedFileExtensions]="['.dll']"
            (onValueChanged)="fileOnValueChanged($event, cellInfo)"
            (onBeforeSend)="fileOnBeforeSend($event, cellInfo)"
            (onUploaded)="fileOnUploaded($event, cellInfo)">
          </dx-file-uploader>
        </ng-container>

        <ng-container *dxTemplate="let cellInfo of 'fileDownloadTemplate'">
          @if (!cellInfo.data.IsSystemArtifact) {
            <a (click)="downloadArtifactData(cellInfo.data)" class="dx-link dx-link-edit">Download</a>
          }
          <span>&nbsp;</span>
        </ng-container>

        <ng-container *dxTemplate="let cellInfo of 'emptyTemplate'">

        </ng-container>
      </dx-data-grid>
    </div>
  </div>
</div>

<ng-template #assemblyTypesTemplate let-c="close" let-d="dismiss">
  <div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="d()">
      <span aria-hidden="true">&times;</span>
    </button>
    <h4 class="modal-title">Available types in uploaded assembly</h4>
  </div>
  <div class="form-group modal-body">
    <dx-data-grid [dataSource]="assemblyInfos"
      [hoverStateEnabled]="true"
      (onSelectionChanged)="selectedAssemblyInfoChanged($event)">
      <dxo-selection mode="single"></dxo-selection>

      <dxi-column dataField="AssemblyType" caption="Type" dataType="string"></dxi-column>
      <dxi-column dataField="ClassName" caption="Class name" dataType="string"></dxi-column>
    </dx-data-grid>
  </div>
  <div class="modal-footer">
    <button class="btn btn-primary" [disabled]="!selectedAssemblyInfo" (click)="c()">Ok</button>
  </div>
</ng-template>

<ng-template #assemblyMultiUploadTemplate let-c="close" let-d="dismiss">
  <div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="d()">
      <span aria-hidden="true">&times;</span>
    </button>
    <h4 class="modal-title">Uploaded artifacts</h4>
  </div>
  <div class="form-group modal-body">
    <app-assembly-artifact-grid [artifacts]="multipleUploadAssemblies"></app-assembly-artifact-grid>
  </div>
  <div class="modal-footer">
    <button class="btn btn-primary" (click)="c()">Save</button>
    <button class="btn btn-primary" (click)="d()">Cancel</button>
  </div>
</ng-template>
